module.exports = __webpack_public_path__ + "static/websites800-5499db2da46305b755768cb400afec70.jpg";